/**
 * Copyright (C) 2020, Merkur India.
 *
 * The program(s) herein may be used and/or copied only with
 * the written permission of Merkur India. or in accordance with
 * the terms and conditions stipulated in the agreement/contract
 * under which the program(s) have been supplied.
 *
 * $Id: HRGameLayoutConstants.ts ,v 1.0 Exp $
 * Date Author Changes
 * 3 July 2020 Sujata Nethani Created
 *
 */
 
namespace BS {
    /**
     * GameLayout constants for the Desktop/HighResolution State
     */
    export class HRGameLayoutConstants {
        public static readonly SYMBOL_WIDTH: number = 280;
        public static readonly SYMBOL_HEIGHT: number = 256;
        public static readonly GAME_WIDTH: number = 1920;
        public static readonly GAME_HEIGHT: number = 1080;

        public static readonly BACKGROUND_X: number = -212;
        public static readonly BACKGROUND_Y: number = -175;
        public static readonly REELOFFSET_X: number = 224;
        public static readonly REELOFFSET_Y: number = 145;
        public static readonly REELOFFSET_GAP: number = 18;

        public static readonly LINE_X: number = 158;
        public static readonly LINE_Y: number = 10;
        public static readonly TAG_LEFT_X: number = 159;
        public static readonly TAG_RIGHT_X: number = 1712;

        public static readonly LINEY = [520, 292, 760, 200, 170];
        public static readonly TAGLEFTY = [499, 272, 738, 180, 833];
        public static readonly TAGRIGHTY = [499, 272, 738, 180, 833];
        
        public static readonly WIN_AMOUNT_BOX = {
                x: 0,
                y:970
        };

        public static readonly SUN_X: number = 110;
        public static readonly SUN_Y: number = 20;
    }
}
